import { render, staticRenderFns } from "./ociBrandSideMenu.vue?vue&type=template&id=bdfe5db0&"
import script from "./ociBrandSideMenu.vue?vue&type=script&lang=js&"
export * from "./ociBrandSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./ociBrandSideMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports